module.exports = __webpack_public_path__ + "static/media/wallball.535744fe.svg";